export default __webpack_public_path__ + "static/media/ASES Shoulder Score.40a1b854.pdf";